<ng-container>
    <div class="ion-padding-top margin-bottom-large">
        <lib-rating-stars
            [rating]="starRating || 0"
            [totalRatings]="totalReviews || 0"
            ratingTextSize="large"
            class="ion-margin-bottom" />

        <p *ngIf="!reviews || reviews.length === 0">0 reviews</p>
    </div>

    <div *ngFor="let r of reviews; let i = index">
        <div class="ion-padding-vertical border-bottom">
            <div class="flex justify-space-between align-items-center">
                <div class="flex align-items-center">
                    @if (r.avatar_url) {
                        <lib-avatar-image [customSize]="36" [image]="r.avatar_url" [name]="r.name" />
                    }
                    <div [ngClass]="{ 'margin-left-small': r.avatar_url }">
                        <h3 class="ion-no-margin text-heading">{{ r.name }}</h3>
                        <p class="ion-no-margin text-small">{{ r.created_at_relative }}</p>
                    </div>
                </div>

                <lib-rating-stars [starSize]="14" [rating]="r.star_rating || 0" [displayRatingAmount]="false" />
            </div>

            <p>{{ r.review }}</p>
        </div>
    </div>
</ng-container>
